// Formatea un monto como "$ xx.xxx,xx" usando locale es-AR.
export const formatCurrencyCart = (amount: number): string => {
  return `$ ${amount?.toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;
};

// Parte un monto en entero y centavos ("$ 850.000" + "00") para mostrar los centavos como superíndice.
export const splitCurrencyCart = (amount: number): { whole: string; cents: string } => {
  const [whole, cents] = formatCurrencyCart(amount).split(',');
  return { whole, cents: cents ?? '00' };
};
